import { queryOptions } from '@tanstack/react-query';
import type { CheckIn } from '@/types/check-in';
import type { Paginated } from '@/types/pagination';
import * as checkInsApi from '../endpoints/check-ins';

export const CHECK_INS_QUERY_KEYS = {
  all: ['check-ins'] as const,
  myActive: () => [...CHECK_INS_QUERY_KEYS.all, 'my', 'active'] as const,
} as const;

export const myActiveCheckInsQueryOptions = () =>
  queryOptions({
    queryKey: CHECK_INS_QUERY_KEYS.myActive(),
    queryFn: async (): Promise<Paginated<CheckIn>> => {
      return checkInsApi.getMyCheckIns({ status: 'active', per_page: 1, page: 1 });
    },
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 15,
    meta: { persist: false },
  });
